import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material';

import MusicUploader from '@shared/components/MusicUploader';
import WaveformTrimmer from '@shared/components/WaveformTrimmer';

import { MusicSectionProps } from '../types';
import styles from './music-section.module.scss';

const MusicSection: FC<MusicSectionProps> = ({
  control,
  isReadOnly,
  setError,
  onTrimmedFileChange,
  musicFieldName,
  waveformTrimmerFieldName,
}) => {
  const { t } = useTranslation();

  return (
    <Box className={styles.formSection}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 2 }}>
        <Typography variant="h5" className={styles.sectionTitle}>{t('client.musicSectionTitle')}</Typography>
        <Tooltip title={t('clientAll.musicUploadTooltip')} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={3000}>
          <IconButton size="small" sx={{ display: 'flex', alignItems: 'center' }}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Controller
            name={musicFieldName}
            control={control}
            render={({ field }) => {
              return (
                <MusicUploader
                  value={field.value ?? ''}
                  isDisabled={isReadOnly}
                  onChange={(file) => {
                    field.onChange(file);
                  }}
                  setError={(msg) => {
                    setError(musicFieldName, { message: msg });
                  }}
                />
              );
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name={musicFieldName}
            control={control}
            render={({ field: musicField }) => {
              const getFileName = (value: File | string | undefined) => {
                if (!value) return '';
                if (typeof value === 'string') {
                  return value.split('/').pop() || value;
                }
                return value.name;
              };
              
              const audioFile = musicField.value instanceof File ? musicField.value : (typeof musicField.value === 'string' && musicField.value ? musicField.value : null);
              const fileName = getFileName(musicField.value);
              
              console.log('🎵 MusicSection - WaveformTrimmer props:', {
                audioFile,
                fileName,
                isReadOnly,
                musicFieldValue: musicField.value
              });
              
              return (
                <WaveformTrimmer
                  audioFile={audioFile}
                  fileName={fileName}
                  disabled={isReadOnly}
                  onTrimChange={(startTime: number, endTime: number) => {
                    console.log('Выбранный отрезок:', { startTime, endTime });
                  }}
                  onTrimmedFileChange={onTrimmedFileChange}
                />
              );
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MusicSection; 